// extracted by mini-css-extract-plugin
module.exports = {"media-breakpoint-md":"(min-width: 960px)","mediaBreakpointMd":"(min-width: 960px)","page":"_1_DXRfHs mx-auto","header":"_28vSVI8Q","body":"_143Gtn50","row":"_2vU5iIyn clearfix"};